module.exports = __webpack_public_path__ + "img/roulette-spades-small.579634a4.svg";